// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: flex;
  align-items: center;
  position: fixed;
  width: 100%;
  background: var(--bg);
  z-index: 100;
  box-sizing: border-box;
  top: 80px;
}

.wrap {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  position: relative;
}

.breadcrumb {
  font-size: 1rem;
  line-height: 1.2rem;
  letter-spacing: 0.05em;
  color: var(--grey);
  white-space: nowrap;
  text-transform: uppercase;
  display: flex;
  align-items: center;
}
.breadcrumb.active {
  color: var(--black);
}

.dropdown {
  border-radius: 0.8rem;
  box-shadow: 0 0.4rem 1rem rgba(97, 97, 97, 0.18);
  display: none;
  flex-direction: column;
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 16;
  overflow: hidden;
  background: var(--white);
  transform: translateY(100%);
}
.dropdown .item {
  font-size: 1.2rem;
  line-height: 1.4rem;
  color: var(--black);
  white-space: nowrap;
  background: var(--white);
  padding: 1rem 1.5rem;
  transition: background 0.2s;
}
.dropdown .item.active {
  background: #e2e1f9;
}
.dropdown .item.disabled {
  opacity: 0.3;
  background: inherit;
  cursor: not-allowed;
}

.slash {
  width: 0.1rem;
  height: 1.8rem;
  background: var(--grey);
  margin: 1rem;
  transform: rotate(15deg);
  display: block;
}

.wrap:hover .dropdown {
  display: flex;
}`, "",{"version":3,"sources":["webpack://./src/shared/breadcrumbs/breadcrumbs.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,qBAAA;EACA,YAAA;EACA,sBAAA;EACA,SAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;AACF;;AAEA;EACE,eAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;AACF;AACE;EACE,mBAAA;AACJ;;AAGA;EACE,qBAAA;EACA,gDAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,gBAAA;EACA,wBAAA;EACA,2BAAA;AAAF;AAEE;EACE,iBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,wBAAA;EACA,oBAAA;EACA,2BAAA;AAAJ;AAEI;EACE,mBAAA;AAAN;AAII;EACE,YAAA;EACA,mBAAA;EACA,mBAAA;AAFN;;AAOA;EACE,aAAA;EACA,cAAA;EACA,uBAAA;EACA,YAAA;EACA,wBAAA;EACA,cAAA;AAJF;;AAQE;EACE,aAAA;AALJ","sourcesContent":[":host {\n  display: flex;\n  align-items: center;\n  position: fixed;\n  width: 100%;\n  background: var(--bg);\n  z-index: 100;\n  box-sizing: border-box;\n  top: 80px;\n}\n\n.wrap {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  position: relative;\n}\n\n.breadcrumb {\n  font-size: 1rem;\n  line-height: 1.2rem;\n  letter-spacing: 0.05em;\n  color: var(--grey);\n  white-space: nowrap;\n  text-transform: uppercase;\n  display: flex;\n  align-items: center;\n\n  &.active {\n    color: var(--black);\n  }\n}\n\n.dropdown {\n  border-radius: 0.8rem;\n  box-shadow: 0 0.4rem 1rem rgba(97, 97, 97, 0.18);\n  display: none;\n  flex-direction: column;\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  z-index: 16;\n  overflow: hidden;\n  background: var(--white);\n  transform: translateY(calc(100%));\n\n  & .item {\n    font-size: 1.2rem;\n    line-height: 1.4rem;\n    color: var(--black);\n    white-space: nowrap;\n    background: var(--white);\n    padding: 1rem 1.5rem;\n    transition: background 0.2s;\n\n    &.active {\n      background: #e2e1f9;\n      // background: rgba(226, 225, 249, 0.33);\n    }\n\n    &.disabled {\n      opacity: 0.3;\n      background: inherit;\n      cursor: not-allowed;\n    }\n  }\n}\n\n.slash {\n  width: 0.1rem;\n  height: 1.8rem;\n  background: var(--grey);\n  margin: 1rem;\n  transform: rotate(15deg);\n  display: block;\n}\n\n.wrap:hover {\n  & .dropdown {\n    display: flex;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
